import { render, staticRenderFns } from "./ConfirmQR.vue?vue&type=template&id=00c53ae6&scoped=true&"
import script from "./ConfirmQR.vue?vue&type=script&lang=ts&"
export * from "./ConfirmQR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c53ae6",
  null
  
)

export default component.exports